import {
  Component,
  inject,
  TemplateRef,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef
} from '@angular/material/snack-bar';
import { ZefSnackTemplateService } from './snack-template.service';
import { ZefSnackType } from './snack.model';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'zef-snack',
  templateUrl: './snack.component.html',
  styleUrls: [ './snack.component.scss' ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ZefSnackComponent implements OnInit, OnDestroy {

  snackRef = inject(MatSnackBarRef<ZefSnackComponent>);
  #data = inject(MAT_SNACK_BAR_DATA);
  #snackTemplates = inject(ZefSnackTemplateService);

  tpl: TemplateRef<any>;
  data: { data: any; type: ZefSnackType; };

  ngOnInit() {
    this.data = this.#data;
    this.tpl = this.#snackTemplates.getTemplate(this.data.type);
  }

  ngOnDestroy() {
    this.close();
  }

  close() {
    if (this.snackRef) {
      this.snackRef.dismiss();
    }
  }
}
